import { Modal, Text, ActionButton } from 'components/commons';
import { DriverStatus } from 'enums';
import { useApi } from 'hooks';
import locale from 'localization';
import React, { useCallback } from 'react';
import styles from './customer-account-status-modal.module.scss';
import { handleRequest } from 'utils';
import CustomerStatus from 'enums/driver-status';
import { updateCustomerAccount } from 'apis/customer.api';

const CustomerAccountStatusModal = ({
  refetchCustomers,
  customerAccountId,
  customerId,
  productId,
  customerName,
  status,
  close,
  active
}) => {
  const { request: updateCustomerAccountRequest, loading: updatingCustomerAccount } = useApi({
    api: updateCustomerAccount
  });

  const updateStatusCb = useCallback(async () => {
    const newStatus = status === CustomerStatus.Active ? CustomerStatus.Terminated : CustomerStatus.Active;

    handleRequest(async () => {
      await updateCustomerAccountRequest({ customerAccountId, customerId, productId, status: newStatus }, () => updateStatusCb());
      refetchCustomers();
      close();
    });
  }, [status, updateCustomerAccountRequest, customerAccountId, customerId, productId, refetchCustomers, close]);

  const deactivateText = (
    <locale.Populate text={locale.youAreAboutDeactivateDriver} items={[<strong>{customerName}</strong>, customerName]} />
  );

  const activateText = (
    <locale.Populate text={locale.youAreAboutReactivateDriver} items={[<strong>{customerName}</strong>, customerName]} />
  );

  return (
    <Modal
      active={active}
      title={status === DriverStatus.Active ? 'Terminate Member Account' : 'Reactivate Member Account'}
      close={close}
      className={styles.modal}
    >
      <div className={styles.content}>
        <Text align="center">{status === CustomerStatus.Active ? deactivateText : activateText}</Text>
      </div>
      <ActionButton
        right
        items={[
          {
            text: locale.cancel,
            onClick: close
          },
          {
            loading: updatingCustomerAccount,
            onClick: updateStatusCb,
            text: status === CustomerStatus.Active ? 'Terminate Account' : locale.yesReactivateIt
          }
        ]}
      />
    </Modal>
  );
};

export default CustomerAccountStatusModal;
